import React, { useState } from 'react'
import { Box, Button, IconButton, TextField } from '@mui/material'
import styles from '../modal.module.css'
import ClearIcon from '@mui/icons-material/Clear';

function ModalSaveProject({ onClose, data, name, onSubmit }) {
    console.log(data)

    return (
        <>
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>บันทึกในโครงการ</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '10px', margin: '10px 0' }}>
                        <Box sx={{ fontWeight: 600 }}>ชื่อโครงการ</Box>
                        <TextField
                            fullWidth
                            size='small'
                            value={name}
                            slotProps={{
                                input: {
                                    readOnly: true,
                                }
                            }}
                        />
                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                variant='contained'
                                onClick={() => {
                                    onSubmit()
                                    onClose()
                                }}>เพิ่มรายชื่อที่เลือก</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalSaveProject
